import { default as teamCalls } from 'helpers/api-calls/team-calls';
import { default as profileCalls } from 'helpers/api-calls/profile-calls';
import { default as actions } from './actions';

function getUserProfileOperation(locationId, userPrivilegeId) {
  return function (dispatch) {
    dispatch(actions.requestUser(userPrivilegeId));
    teamCalls.getTeamMember(locationId, userPrivilegeId).then( (response) => {
        return dispatch(actions.receiveUserPrivilege(response.data));
      }, (error) => {
        console.log(error);
      }
    );
  };
}

function updateUserOperation(userId, payload) {
  return function (dispatch) {
    profileCalls.updateUser(userId, payload).then((response) => {
        dispatch(actions.updateUser(response.data.user));
    }, (error) => {
        console.log(error);
    });
  };
}

function updateUserPrivilegeOperation(userPrivilegeId, payload) {
  return function (dispatch) {
    profileCalls.updateUserPrivilege(userPrivilegeId, payload).then((response) => {
        dispatch(actions.updateUserPrivilege(response.data));
    }, (error) => {
        console.log(error);
    });
  };
}

function removeUserAvatarOperation(userId) {
  return function (dispatch) {
    profileCalls.removeUserAvatar(userId).then((response) => {
      console.log(response.data);
        dispatch(actions.updateUser(response.data.user));
    }, (error) => {
      console.log(error);
    });
  }
}

function removeChannelFromUserOperation(userId, channelId) {
  return function (dispatch) {
    teamCalls.removeUserFromChannel({channel_id: channelId, user_id: userId}).then((response) => {
       const payload = { user_id: userId, channel_id: channelId };
      dispatch(actions.removeChannelFromUser(payload));
    }, (error) => {
      console.log(error);
    });
  };
}

function addChannelToUserOperation(userId, channelId) {
  return function (dispatch) {
    teamCalls.addUserToChannel(channelId, userId).then((response) => {
      const payload = { user_id: userId, channel_id: channelId };
      dispatch(actions.addChannelToUser(payload));
    }, (error) => {
      console.log(error);
    });
  };
}

function removeUserPrivilegeOperation (userPrivilegeId, callback) {
  return function (dispatch) {
    profileCalls.deleteUserByPrivilegeId(userPrivilegeId).then((response) => {
      dispatch(actions.resetUserProfile());
      callback();
    }, (error) => {
      console.log(error);
    });
  };
}

function resetUserProfileOperation() {
  return function (dispatch) {
    const user = {}
    dispatch(actions.updateUser(user));
  };
}

export default {
  updateUserOperation,
  getUserProfileOperation,
  resetUserProfileOperation,
  removeUserAvatarOperation,
  updateUserPrivilegeOperation,
  removeChannelFromUserOperation,
  addChannelToUserOperation,
  removeUserPrivilegeOperation,
};
